import styled from "styled-components";

export const StyledPlayableZone = styled.div`
	height: calc(100% - 44px);
	width: 100vw;
	max-width: 421px;
`;
